/** Lower-case, diacritics stripped (Höfe → hofe, also matches "hoefe"), ß → ss. */
export function normalizeForSearch(value: string): string {
  return value
    .toLowerCase()
    .replace(/ß/g, 'ss')
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

const foldUmlautSpelling = (value: string) => value.replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');

/**
 * True when every word of the filter occurs in one of the fields (empty filter matches
 * everything; missing fields are skipped). "Hoefe" and "Höfe" both hit "Höfe".
 */
export function matchesSearchText(fields: readonly (string | null | undefined)[], filter: string): boolean {
  const words = normalizeForSearch(filter.trim()).split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = normalizeForSearch(fields.filter(Boolean).join(' '));
  const haystackAscii = foldUmlautSpelling(haystack);
  return words.every(word => haystack.includes(word) || haystackAscii.includes(foldUmlautSpelling(word)));
}

/** True when the zone's name or id contains the filter (empty filter matches everything). */
export function matchesZoneFilter(zone: { name: string; id: string }, filter: string): boolean {
  return matchesSearchText([zone.name, zone.id], filter);
}
